import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { Card } from '../../../types/card';
import { UniversalState } from '../../../types/state';
import API from '../../../util/api';
import { buildURLQuery } from '../../../util/manipulate';

export interface IFetchCardPayload {
  isCompanyCard?: boolean
}

export const fetchCardThunk = createAsyncThunk('card/fetchCard', async (payload: IFetchCardPayload = {}) => {
  const { isCompanyCard = false } = payload;
  const query: any = {
  }
  if (isCompanyCard) {
    query.isCompanyCard = isCompanyCard
  }
  const urlQuery = buildURLQuery(query)
  const url = `card?${urlQuery}`;
  const result = await API.get(url);
  return result.data as Card[];
});

export const createCardThunk = createAsyncThunk(
  'card/createCard',
  async (data, { dispatch }) => {
    await API.post('card', data);
    await dispatch(fetchCardThunk({}));
  },
);

export const deleteCardThunk = createAsyncThunk(
  'card/deleteCard',
  async (data, { dispatch }) => {
    await API.delete(`card/${data}`);
    await dispatch(fetchCardThunk({}));
  },
);

const initialState: UniversalState<Card[]> = {
  data: [],
  loading: false,
  error: null,
};

const cardSlice = createSlice({
  name: 'card',
  initialState,
  reducers: {
    clearCardSubmitting(state) {
      state.isSubmitting = undefined;
      state.error = null;
    },
    clearCardData(state) {
      state.data = []
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCardThunk.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchCardThunk.fulfilled, (state, action) => {
      state.data = action.payload;
      state.loading = false;
    });
    builder.addCase(fetchCardThunk.rejected, (state, action) => {
      state.loading = false;
      state.error = action;
    });
    builder.addCase(createCardThunk.pending, (state) => {
      state.isSubmitting = true;
      state.error = null;
    });
    builder.addCase(createCardThunk.fulfilled, (state) => {
      state.isSubmitting = false;
      state.error = null;
    });
    builder.addCase(createCardThunk.rejected, (state, action) => {
      state.isSubmitting = false;
      state.error = action;
    });
    builder.addCase(deleteCardThunk.pending, (state) => {
      state.isSubmitting = true;
      state.error = null;
    });
    builder.addCase(deleteCardThunk.fulfilled, (state) => {
      state.isSubmitting = false;
      state.error = null;
    });
    builder.addCase(deleteCardThunk.rejected, (state, action) => {
      state.isSubmitting = false;
      state.error = action;
    });
  },
});

const { reducer, actions } = cardSlice;

export const { clearCardSubmitting, clearCardData } = actions;

export default reducer;
